import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { RiArrowDropDownLine } from "react-icons/ri";
import ModalWithSearchbar from "../modals/modalWithSearchbar";
import DateModal from "../modals/dateModal";
import "./filters.css";
import { readableColor } from "polished";
import { colorBrandObject } from "../../../constants/brandings";

function Filter({
  filteredSchema = [],
  handleSearchbarModalData = () => { },
  handleDateModalData = () => { },
  value = [],
  pspCodes,
  useTabStyling,
}) {


  const [schemaId, setSchemaId] = useState("");
  const [modalListLabels, setModalListLabels] = useState([]);
  const [modalLabel, setModalLabel] = useState([]);
  const [multiselector, setMultiselector] = useState([]);
  const [openSearchbarModal, setOpenSearchbarModal] = useState(false);
  const [openDateModal, setOpenDateModal] = useState(false);
  const [displayLogo, setDisplayLogo] = useState(false);
  const [showTitleType, setShowTitleType] = useState("");
  const [uniqueType, setUniqueType] = useState("");
  const [showFilterTitle, setShowFilterTitle] = useState(false);

  const fliterButton = (item) => {
    setSchemaId(item.id);
    setModalListLabels(item.items);
    setModalLabel(item.label);
    setMultiselector(item.multiselector);
    setDisplayLogo(item?.displayLogo);
    setShowTitleType(item?.showTitleType);
    setUniqueType(item?.uniqueType);
    setShowFilterTitle(item?.filterTitle)
    if (
      item?.id == "operationName" ||
      item?.id == "operationStatus" ||
      item?.id == "finalStatus" ||
      item?.id == "status" ||
      item?.id == "pspCode" ||
      item?.id == "paymentMethodType" ||
      item?.id == "countryCode" ||
      item?.id == "currencyCode" ||
      item?.id == "processor" ||
      item?.id == "metadata.SETTLEMENT_CURRENCY" ||
      item?.id == "paymentMethodSubType" ||
      item?.id == "legalEntity" ||
      item?.id == "fileSetCode"
    ) {
      setOpenSearchbarModal(true);
    } else if (item?.id === "timestamp") {
      setOpenDateModal(true);
    }
  };

  const handleCloseSearchbarModal = () => {
    setOpenSearchbarModal(false);
  };

  const handleCloseDateModal = () => {
    setOpenDateModal(false);
  };

  const [withSearchModalData, setWithSearchModalData] = useState([]);
  const [dateModalData, setDateModalData] = useState([]);

  useEffect(() => {
    const path = window.location.pathname;
    let storedData = [];
    let storedDate = [];
    if (path === "/analytics") {
      const stored = JSON.parse(localStorage.getItem("Analyticsfilters"));
      storedData = stored ? stored : [];
    }

    setWithSearchModalData(storedData);
    handleSearchbarModalData(storedData);

    if (storedDate) {
      setDateModalData(storedDate);
      handleDateModalData(storedDate);
    }
  }, []);

  const handleSearchbarData = (data) => {
    setWithSearchModalData(data);
    handleSearchbarModalData(data);
    if (window.location.pathname === "/transactions") {
      localStorage.setItem("Orderfilters", JSON.stringify(data));
    } else if (window.location.pathname === "/analytics") {
      localStorage.setItem("Analyticsfilters", JSON.stringify(data));
    }
  };

  const handleDateData = (data) => {
    handleDateModalData(data);
    setDateModalData(data);
    if (window.location.pathname === "/transactions") {
      localStorage.setItem("OrderDate", JSON.stringify(data));
    }
  };

  const [transactionValueLength, setTransactionValueLength] = useState(0);
  const [statusValueLength, setStatusValueLength] = useState(0);
  const [fileSetCodeValueLength, setFileSetCodeValueLength] = useState(0);
  const [processorValueLength, setProcessorValueLength] = useState(0);
  const [methodValueLength, setMethodValueLength] = useState(0);
  const [countryValueLength, setCountryValueLength] = useState(0);
  const [currencyValueLength, setCurrencyValueLength] = useState(0);
  const [dateModalLength, setDateModalLength] = useState(0);
  const [paymentMethodsLength, setPaymentMethodsLength] = useState(0);
  const [businessUnitLength, setBusinessUnitLength] = useState(0);

  const countCheckboxWithModalData = () => {
    const fileSetCodeObj = withSearchModalData?.find((obj) => obj.id === "fileSetCode");
    setFileSetCodeValueLength(fileSetCodeObj ? fileSetCodeObj?.value?.length : 0);
    const transactionTypeObj = withSearchModalData?.find((obj) => obj.id === "operationName");
    setTransactionValueLength(transactionTypeObj ? transactionTypeObj?.value?.length : 0);
    const statusTypeObj = withSearchModalData?.find((obj) => obj.id === "operationStatus" || obj.id === "status" || obj.id === 'finalStatus');
    setStatusValueLength(statusTypeObj ? statusTypeObj?.value?.length : 0);
    const methodTypeObj = withSearchModalData.find((obj) => obj.id === "paymentMethodType");
    setMethodValueLength(methodTypeObj ? methodTypeObj.value.length : 0);
    const processorTypeObj = withSearchModalData.find((obj) => obj.id === "pspCode" || obj.id === "processor");
    setProcessorValueLength(processorTypeObj ? processorTypeObj.value.length : 0);
    const countryTypeObj = withSearchModalData.find((obj) => obj.id === "countryCode" || obj.id === "metadata.SETTLEMENT_CURRENCY");
    const paymentMethodsLengthTypeObj = withSearchModalData?.find((obj) => obj.id === "paymentMethodSubType");
    setPaymentMethodsLength(paymentMethodsLengthTypeObj ? paymentMethodsLengthTypeObj?.value?.length : 0);
    const businessUnitLengthTypeObj = withSearchModalData?.find((obj) => obj.id === "legalEntity");
    setBusinessUnitLength(businessUnitLengthTypeObj ? businessUnitLengthTypeObj?.value?.length : 0);
    setCountryValueLength(countryTypeObj ? countryTypeObj.value.length : 0);
  };

  useEffect(() => {
    countCheckboxWithModalData();
  }, [withSearchModalData]);

  useEffect(() => {
    const lengthofOjbect = dateModalData?.selectedValue?.length;
    setDateModalLength(lengthofOjbect);
  }, [dateModalData]);

  return (
    <div style={{ display: "flex", gap: "12px" }}>
      {filteredSchema.length > 0 &&
        filteredSchema.map((item, idx) => {
          return (
            <Button
              key={idx}
              onClick={() => fliterButton(item)}
              endIcon={
                <RiArrowDropDownLine
                  style={{
                    width: "20px",
                    height: "20px",
                    border: "2px",
                    color: "black",
                  }}
                />
              }
              className={
                useTabStyling
                  ? "filter-conatiner-with-tabs"
                  : "filter-conatiner"
              }
              focusRipple={false}
              disableRipple={true}
            >
              {item?.id == "operationName" && transactionValueLength > 0 && (
                <div className="options-selected" style={{
                  color: readableColor(colorBrandObject?.secondaryButtonColor),
                  backgroundColor: colorBrandObject?.secondaryButtonColor
                }}>{transactionValueLength}</div>
              )}
              {(item?.id == "operationStatus" || item?.id === "status") &&
                statusValueLength > 0 && (
                  <div className="options-selected" style={{
                    color: readableColor(colorBrandObject?.secondaryButtonColor),
                    backgroundColor: colorBrandObject?.secondaryButtonColor
                  }}>{statusValueLength}</div>
                )}{" "}
              {(item?.id == "fileSetCode") &&
                fileSetCodeValueLength > 0 && (
                  <div className="options-selected" style={{
                    color: readableColor(colorBrandObject?.secondaryButtonColor),
                    backgroundColor: colorBrandObject?.secondaryButtonColor
                  }}>{fileSetCodeValueLength}</div>
                )}{" "}
              {item?.id == "paymentMethodType" && methodValueLength > 0 && (
                <div className="options-selected" style={{
                  color: readableColor(colorBrandObject?.secondaryButtonColor),
                  backgroundColor: colorBrandObject?.secondaryButtonColor
                }}>{methodValueLength}</div>
              )}{" "}
              {(item?.id == "pspCode" || item?.id === "processor") &&
                processorValueLength > 0 && (
                  <div className="options-selected" style={{
                    color: readableColor(colorBrandObject?.secondaryButtonColor),
                    backgroundColor: colorBrandObject?.secondaryButtonColor
                  }}>{processorValueLength}</div>
                )}
              {(item?.id == "countryCode" ||
                item?.id === "metadata.SETTLEMENT_CURRENCY") &&
                countryValueLength > 0 && (
                  <div className="options-selected" style={{
                    color: readableColor(colorBrandObject?.secondaryButtonColor),
                    backgroundColor: colorBrandObject?.secondaryButtonColor
                  }}>{countryValueLength}</div>
                )}{" "}
              {item?.id === "timestamp" && dateModalLength > 0 && (
                <div className="options-selected" style={{
                  color: readableColor(colorBrandObject?.secondaryButtonColor),
                  backgroundColor: colorBrandObject?.secondaryButtonColor
                }}>1</div>
              )}{" "}
              {item?.id === "paymentMethodSubType" &&
                paymentMethodsLength > 0 && (
                  <div className="options-selected" style={{
                    color: readableColor(colorBrandObject?.secondaryButtonColor),
                    backgroundColor: colorBrandObject?.secondaryButtonColor
                  }}>{paymentMethodsLength}</div>
                )}{" "}
              {item?.id === "legalEntity" && businessUnitLength > 0 && (
                <div className="options-selected" style={{
                  color: readableColor(colorBrandObject?.secondaryButtonColor),
                  backgroundColor: colorBrandObject?.secondaryButtonColor
                }}>{businessUnitLength}</div>
              )}{" "}
              {item?.label}
            </Button>
          );
        })}

      <ModalWithSearchbar
        modalLabel={modalLabel}
        schemaId={schemaId}
        modalListLabels={modalListLabels}
        multiselector={multiselector}
        sendDataFromWithSearchbar={handleSearchbarData}
        openModal={openSearchbarModal}
        onClose={handleCloseSearchbarModal}
        displayLogo={displayLogo}
        uniqueType={uniqueType}
        showTitleType={showTitleType}
        value={value}
        searchbarData={withSearchModalData}
        showFilterTitle={showFilterTitle}
      />

      <DateModal
        sendDataFromDateModal={handleDateData}
        openModal={openDateModal}
        onClose={handleCloseDateModal}
        presentData={dateModalData}
      />
    </div>
  );
}

export default Filter;

